import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Zap } from "lucide-react";
import { NAV_LINKS, AFFILIATION } from "@/data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass-nav" : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="container-x flex items-center justify-between h-[72px]">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center group"
        >
          <img src="/logo.png" alt="TopAffiliation" className="h-9 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-brand-red ${
                  isActive ? "text-brand-red" : "text-white/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <a
            href={AFFILIATION.login}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-login"
            className="text-sm font-semibold text-white/85 hover:text-brand-red transition-colors"
          >
            Accedi
          </a>
          <a
            href={AFFILIATION.signup}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-register"
            className="btn-glow inline-flex items-center rounded-full bg-brand-red px-5 py-2.5 text-sm font-semibold text-white hover:bg-brand-redDark hover:scale-[1.03]"
          >
            Iscriviti subito
          </a>
        </div>

        <button
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          className="md:hidden grid place-items-center h-10 w-10 rounded-lg border border-white/10 text-white"
          aria-label="Menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden glass-nav border-t border-white/10 px-6 py-6 flex flex-col gap-4"
        >
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-base font-medium ${isActive ? "text-brand-red" : "text-white/85"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={AFFILIATION.login}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-login"
            className="mt-2 inline-flex justify-center rounded-full border border-white/15 px-5 py-3 text-sm font-semibold text-white"
          >
            Accedi
          </a>
          <a
            href={AFFILIATION.signup}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-cta-register"
            className="inline-flex justify-center rounded-full bg-brand-red px-5 py-3 text-sm font-semibold text-white"
          >
            Iscriviti subito
          </a>
        </div>
      )}
    </header>
  );
};
